import { hiprint, defaultElementTypeProvider } from './hiprint/hiprint.bundle.js'
import { version as epVersion } from 'element-plus/package.json'
import semver from 'semver'
// 调用浏览器打印js
import './hiprint/plugins/jquery.hiwprint.js'
// 默认配置
import './hiprint/hiprint.config'
// 样式
import './hiprint/css/hiprint.css'
import './hiprint/css/print-lock.css'

// 扩展Window接口类型定义
declare global {
  interface Window {
    autoConnect?: boolean
    hiwebSocket?: {
      hasIo(): boolean
      start(cb?: (status: boolean, msg?: any) => void): void
      stop(): void
    }
    hiprint?: any
  }
}

// 定义回调函数类型
type ConnectCallback = (status: boolean, msg?: any) => void

/**
 * 自动连接 / 连接
 * cb: 连接回调， (status, msg) {
 *   // status: true/false
 *   // msg: status == true 时 返回socket.connect回调 e
 * }
 */
const autoConnect = function (cb?: ConnectCallback): void {
  console.log('autoConnect')
  window.autoConnect = false
  window.hiwebSocket && window.hiwebSocket.hasIo() && window.hiwebSocket.start(cb)
}

/**
 * 取消自动连接 / 断开连接
 */
const disAutoConnect = function (): void {
  console.log('disAutoConnect')
  window.autoConnect = false
  window.hiwebSocket && window.hiwebSocket.hasIo() && window.hiwebSocket.stop()
}

// 定义Vue类型接口
interface VueInstance {
  prototype?: any
  config?: {
    globalProperties?: any
  }
}

interface PrintOptions {
  [key: string]: any
}

interface PrintData {
  [key: string]: any
}

const hiPrintPlugin = {
  disAutoConnect,
  install: function (
    Vue: VueInstance,
    name: string = '$hiPrint',
    autoConnectFlag: boolean = true,
  ): void {
    const requiredVersion = '2.10.0'
    if (!semver.satisfies(epVersion, `^${requiredVersion}`)) {
      console.warn(
        `[erp-print] Warning: Incompatible Element Plus version.
        Expected a version compatible with ^${requiredVersion}, but got ${epVersion}.
        This may cause unexpected issues.`,
      )
    }
    if (!autoConnectFlag) {
      disAutoConnect()
    }
    const globalVue = Vue.prototype || Vue.config?.globalProperties
    if (globalVue) {
      globalVue[name] = hiprint

      /**
       * 预览打印，调起系统打印预览
       * provider 左侧拖拽元素
       * template 模版json字符串
       * args 打印数据data, options,
       */
      globalVue.$print = function (
        provider: any = defaultElementTypeProvider,
        template: string | object,
        data?: PrintData,
        options?: PrintOptions,
      ): any {
        hiprint.init({
          providers: [new provider()],
        })
        const printInstance = new hiprint.PrintTemplate({
          template: template,
        })
        printInstance.print(data, options)
        return printInstance
      }

      /**
       * 单模版直接打印， 需客户端支持
       * provider 左侧拖拽项对象
       * template 模版json字符串
       * args 打印数据data, options,
       */
      globalVue.$print2 = function (
        provider: any = defaultElementTypeProvider,
        template: string | object,
        data?: PrintData,
        options?: PrintOptions,
      ): any {
        hiprint.init({
          providers: [new provider()],
        })
        const printInstance = new hiprint.PrintTemplate({
          template: template,
        })
        printInstance.print2(data, options)
        return printInstance
      }
    }
  },
}

window.hiprint = hiprint

// 组件和插件导出
export { autoConnect, disAutoConnect, hiprint, hiPrintPlugin, defaultElementTypeProvider }

// 类型导出
export type { PrintOptions, PrintData }

// 从PrintDesigner导出类型
export type {
  PrintDesignerConfig,
  TemplateData,
  UploadConfig,
  BusinessFieldsConfig,
  // UIConfig,
  ControlItem,
  BusinessField,
  BusinessFieldGroup,
  PrintDesignerEvents,
  PrintDesignerMethods,
} from './types/PrintDesignerTypes'

// 导出PrintDesigner组件
export { default as PrintDesigner } from './PrintDesigner.vue'
